<template>
  <t-row class="list-view-record" ref="row">
    <bulk-action-checkbox v-if="canTakeBulkActions"  :entry="entry"></bulk-action-checkbox>
    <t-prefix v-if="$feature.isOn('see_underlying_properties')" >
      <button class="btn-icon blue" @click="showSeeUnderlyingPropertiesModal">
        <icon class="inspection"></icon>
        <span class="sr-only">See Underling Properties</span>
      </button>
    </t-prefix>
    <underlying-properties-modal
      @toggle-modal="hideModal(vueModalID.seeUnderlyingProperties)"
      :object-model-entry="entry"
      :object-model="objectModel"
      v-if="modalStateFor(vueModalID.seeUnderlyingProperties).isVisible && isNotOneStop"
      :state="modalStateFor(vueModalID.seeUnderlyingProperties)"
      :index="vueModalID.seeUnderlyingProperties"
    />
    <list-view-content-element-column
      v-for="column in columns"
      :is-in-detail-view-edit-mode="isInDetailViewEditMode"
      :key="`column-${column.id}`"
      :content-element="column"
      :horizontal="horizontal"
      :entry="entry"
      :list-view="listView"
      :user="user"
      :is-user-dashboard="isUserDashboard"
      @updateEntries="updateEntries"
    />
  </t-row>
</template>

<script lang="ts">
  import Vue from "vue";
  import listViewTableMixin from "../mixins/listViewTableMixin";
  import ListViewContentElementColumn from "./list-view-content-element-column.vue";
  import ObjectModelFakeEntry from "../../../common/models/objectModelEntries/objectModelFakeEntry";
  import ObjectModelEntry from "../../../common/models/objectModelEntries/objectModelEntry";
  import BulkActionCheckbox from "../../../common/components/bulk-action-checkbox.vue"
  import ListViewContentElement from '../../../common/models/listViews/elements/listViewContentElement'
  import UnderlyingPropertiesModal from "~/components/experimental/see-underlying-properties-modal.vue"
  import isOneStop from "~/mixins/isOneStop";
  import User from "~/models/user";
  import listViewAvailableBulkActionsMixin from '~/mixins/listViewAvailableBulkActionsMixin';

  export default Vue.extend({
    components: {
      ListViewContentElementColumn,
      BulkActionCheckbox,
      UnderlyingPropertiesModal
    },
    mixins: [
      listViewAvailableBulkActionsMixin,
      listViewTableMixin,
      isOneStop
    ],
    props: {
      isInDetailViewEditMode:{
        type: Boolean,
        default: false
      },
      entry: {
        type: Object as () => ObjectModelFakeEntry | ObjectModelEntry
      },
      nestedElements: {
        type: Array as () => ListViewContentElement[],
        default: null,
      },
      horizontal: {
        type: Boolean,
        default: true,
      },
      isUserDashboard: {
        type: Boolean,
        default: false
      },
      user: {
        type: User
      }
    },
    mounted() {
      this.$nextTick(function () {
        if (this.highlightedEntryId === this.entry.id) {
          setTimeout(() => {
            const params = new URLSearchParams(window.location.search);
            const discarded = params.get("discarded")

            const row = this.$refs.row;
            row.$el.scrollIntoView({behavior: 'smooth'});
            if (!discarded) {
              row.$el.className += ' highlight-row'
            }
          }, 0);
        }
      })
    },
    methods:{
      showSeeUnderlyingPropertiesModal(){
        this.showModal(this.vueModalID.seeUnderlyingProperties)
      },
      updateEntries(entry) {
        return this.$emit('updateEntries', entry);
      }
    },
    computed: {
      highlightedEntryId() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('highlighted_entry_id');
      },
      objectModel(){
        const view = this.listView;
        return view.published_object_model || view.object_model
      },
      columns() {
        if (this.nestedElements) {
          return this.nestedElements
        } else {
          return this.contentElement.contentElementsArray;
        }
      },
      canTakeBulkActions(): boolean {
        return this.listView.viewers_can_take_bulk_actions && (this.isPreview || this.availableBulkActions.length > 0);
      },
    },
  });
</script>